import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './GalleryPlaceholder.css';

export interface IGalleryPlaceholderProps {
  isFat?: boolean;
  imageUrl?: string;
  isMobile?: boolean;
}

export function GalleryPlaceholder({ isFat, imageUrl, isMobile }: IGalleryPlaceholderProps) {
  return (
    <div
      {...mergeStyles(styles['container'], isFat && styles['container--fat'], isMobile && styles['container--mobile'])}
    >
      <div className={styles['content']}>{imageUrl && <img className={styles['image']} src={imageUrl} alt="" />}</div>
    </div>
  );
}
